import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="input"
export default class extends Controller {
  setValue(value) {
    this.element.value = value;
    // Programmatic assignment does not fire input events; dispatch one so
    // listeners (e.g. date-time-picker) can react to calendar selections.
    this.element.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
